import { render, staticRenderFns } from "./DetailBlock1Edit.vue?vue&type=template&id=61f6936e&scoped=true"
import script from "./DetailBlock1Edit.vue?vue&type=script&lang=js"
export * from "./DetailBlock1Edit.vue?vue&type=script&lang=js"
import style0 from "./DetailBlock1Edit.vue?vue&type=style&index=0&id=61f6936e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6936e",
  null
  
)

export default component.exports